
import Vue from 'vue'
import ElementUI from 'element-ui' 
import 'element-ui/lib/theme-chalk/index.css' 
Vue.use(ElementUI) 
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Previewer from 'vux/src/components/previewer/index.vue'

import VuePreview from 'vue-preview'
import photoImg from '@/assets/photo.png'
export default {
directives: {
TransferDom
},
components: {
Previewer
},
props: {
title: {
type: String,
default: ''
},
is_upload: {
type: Boolean,
default: true
},
files: {
type: Array,
default: []
},
show_list: {
type: Boolean,
default: true
},
limit: {
type: Number,
default: 1
},
size: {
type: Number,
default: 5 // 单位M，图片最大size
},
upLoadUrl: {
type: String,
default: 'fileUp.ashx?action=UploadOBS'
},
view_type: {
type: String,
default: 'grid' // cell,grid
},
params: {
type: Object,
default: function() {
return {}
}
},
accept: {
type: String,
default: 'image/gif,image/jpeg,image/jpg,image/png,image/svg'
}
},
computed: {
imgs() {
console.log(this.title, JSON.stringify(this.files))
if (this.view_type == 'cell') {
return this.files.slice(-1 * this.limit);
} else {
return this.files;
}
},
prj_code() {
return this.$store.state.app.prj_code
},
uploadAction() {
const code = this.prj_code
if (code === 'Asus' || code === 'Acer') {
return this.upLoadUrl
}
return 'fileUp.ashx?action=Upload'
}
},
data() {
console.log('upload data', this.title, JSON.stringify(this.files))
return {
is_upload_class: this.is_upload ? '' : 'upload-disabled',
view_class: this.view_type == 'cell' ? 'cell-upload-plugin' : 'grid-upload-plugin',
photoImg: photoImg,
headerMsg: {},
multiple: this.limit > 1 ? true : false,
options: { //需正确配置
getThumbBoundsFn(index) {
let thumbnail = document.querySelectorAll('.el-upload-list__item-thumbnail')[index];
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
let rect = thumbnail.getBoundingClientRect()
return {
x: rect.left,
y: rect.top + pageYScroll,
w: rect.width
}
}
}
}
},
methods: {
onBeforeUpload(file) {
console.log('onBeforeUpload', this.files.length)
let _this = this;

const isAccept = !_this.accept || _this.accept.indexOf(file.type) != -1;

const isLimitSize = file.size / 1024 / 1024 < _this.size;
if (!isAccept) {
this.$message.error('上传文件只能是 ' + _this.accept + ' 格式!');
return false;
}
if (!isLimitSize) {
this.$message.error('上传文件大小不能超过 ' + _this.size + 'MB!');
return false;
}
return true;
},
onChange(file, fileList) {},
onPreview(file) {
let index = this.imgs.indexOf(file)
this.$refs.previewer.show(index);
},
onExceed(files) {



if (files.length + this.files.length > this.limit) {
this.$toast.text('最多只能上传' + this.limit + '个文件')
}
},
onError() {

},
onRemove(file, fileList) {
let index = this.files.indexOf(file)
this.$parent.files = fileList
this.files.splice(index, 1)
},
onSuccess(res, file) {
if (res.Code == 1) {
let _this = this
let img = new Image()
file.URL = res.Data
_this.files.push(file)
if (res.Data.indexOf('http') == -1) {
img.src = _this.$store.getters.getFileRoot + res.Data
} else {
img.src = res.Data
}

img.onload = function() {
file.src = img.src
file.msrc = img.src
file.w = img.width
file.h = img.height
}
_this.$emit('onSuccess', file)
} else {
this.$toast.text(res.Msg || '上传失败')
return false
}
}
},
}



// WEBPACK FOOTER //
// ./src/components/Upload.vue